const auditApplyUnfreezingFunds = {
    path: 'auditApplyUnfreezingFunds',
    component: resolve => require(['@/pages/admin/riskMerchantHandle/auditApplyUnfreezingFunds'], resolve)
}
export default auditApplyUnfreezingFunds